import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { useIsTruncated } from '../../hooks/use_is_truncated.js';
import { useTranslations } from '../../hooks/use_translations.js';
import { spacing2x, spacing1x } from '../../styles/spacing.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { onlyText } from '../../utils/react.js';
import { Button } from '../Button/Button.js';
import '../Icons/IconActivity.js';
import '../Icons/IconActivityOff.js';
import '../Icons/IconAdd.js';
import '../Icons/IconAddToCart.js';
import '../Icons/IconAlignBottom.js';
import '../Icons/IconAlignCenter.js';
import '../Icons/IconAlignJustify.js';
import '../Icons/IconAlignLeft.js';
import '../Icons/IconAlignMiddle.js';
import '../Icons/IconAlignRight.js';
import '../Icons/IconAlignTop.js';
import '../Icons/IconAnnotate.js';
import '../Icons/IconApps.js';
import '../Icons/IconArchive.js';
import '../Icons/IconArrowBack.js';
import '../Icons/IconArrowDown.js';
import '../Icons/IconArrowLeft.js';
import '../Icons/IconArrowRight.js';
import '../Icons/IconArrowUp.js';
import '../Icons/IconAskExpert.js';
import '../Icons/IconAtMention.js';
import '../Icons/IconAttach.js';
import '../Icons/IconBold.js';
import '../Icons/IconCalendar.js';
import '../Icons/IconCalendarDay.js';
import '../Icons/IconCaretDown.js';
import '../Icons/IconCaretUp.js';
import '../Icons/IconCheck.js';
import { IconClose } from '../Icons/IconClose.js';
import '../Icons/IconCloseContextualPanel.js';
import '../Icons/IconCloudSync.js';
import '../Icons/IconCloudUpload.js';
import '../Icons/IconCode.js';
import '../Icons/IconCollapsePanel.js';
import '../Icons/IconCollection.js';
import '../Icons/IconColor.js';
import '../Icons/IconColumns.js';
import '../Icons/IconComment.js';
import '../Icons/IconContentPlanner.js';
import '../Icons/IconCopy.js';
import '../Icons/IconCorporations.js';
import '../Icons/IconCRM.js';
import '../Icons/IconCustomDelivery.js';
import '../Icons/IconCustomize.js';
import '../Icons/IconDash.js';
import '../Icons/IconDatasource.js';
import '../Icons/IconDelete.js';
import '../Icons/IconDependentField.js';
import '../Icons/IconDocCenter.js';
import '../Icons/IconDownload.js';
import '../Icons/IconDrag.js';
import '../Icons/IconEdit.js';
import '../Icons/IconEditForm.js';
import '../Icons/IconEditNew.js';
import '../Icons/IconEmail.js';
import '../Icons/IconEmailBlast.js';
import '../Icons/IconEmailComponent.js';
import '../Icons/IconEmailTemplate.js';
import '../Icons/IconEmoji.js';
import '../Icons/IconEngagements.js';
import '../Icons/IconExpire.js';
import '../Icons/IconExport.js';
import '../Icons/IconExternal.js';
import '../Icons/IconFavoriteSelected.js';
import '../Icons/IconFavoriteUnselected.js';
import '../Icons/IconFile.js';
import '../Icons/IconFileAdd.js';
import '../Icons/IconFileEdit.js';
import '../Icons/IconFileLock.js';
import '../Icons/IconFileMove.js';
import '../Icons/IconFileRemove.js';
import '../Icons/IconFileSearch.js';
import '../Icons/IconFileShare.js';
import '../Icons/IconFileStar.js';
import '../Icons/IconFileSync.js';
import '../Icons/IconFileZip.js';
import '../Icons/IconFilter.js';
import '../Icons/IconFolder.js';
import '../Icons/IconFolderAdd.js';
import '../Icons/IconFolderEdit.js';
import '../Icons/IconFolderOpen.js';
import '../Icons/IconFolderRemove.js';
import '../Icons/IconFolderSearch.js';
import '../Icons/IconFolderShare.js';
import '../Icons/IconFolderStar.js';
import '../Icons/IconFolderSync.js';
import '../Icons/IconFolderTeam.js';
import '../Icons/IconFolderZip.js';
import '../Icons/IconFullscreen.js';
import '../Icons/IconGenericSort.js';
import '../Icons/IconGlobal.js';
import '../Icons/IconGoogleDrive.js';
import '../Icons/IconGrid.js';
import '../Icons/IconGroupBy.js';
import '../Icons/IconHandClosed.js';
import '../Icons/IconHandOpen.js';
import '../Icons/IconHome.js';
import '../Icons/IconIndentDecrease.js';
import '../Icons/IconIndentIncrease.js';
import '../Icons/IconInsights.js';
import '../Icons/IconIntegrations.js';
import '../Icons/IconInternalSync.js';
import '../Icons/IconItalic.js';
import '../Icons/IconLaptop.js';
import '../Icons/IconLayout.js';
import '../Icons/IconLibrary.js';
import '../Icons/IconLightbulb.js';
import '../Icons/IconLike.js';
import '../Icons/IconLikeDisabled.js';
import '../Icons/IconLineHeight.js';
import '../Icons/IconLink.js';
import '../Icons/IconList.js';
import '../Icons/IconListNumbers.js';
import '../Icons/IconLiveSocial.js';
import '../Icons/IconLocate.js';
import '../Icons/IconLock.js';
import '../Icons/IconLogic.js';
import '../Icons/IconMedia.js';
import '../Icons/IconMediaCC.js';
import '../Icons/IconMediaCCActive.js';
import '../Icons/IconMediaControlPrevious.js';
import '../Icons/IconMediaForward.js';
import '../Icons/IconMediaFull.js';
import '../Icons/IconMediaLow.js';
import '../Icons/IconMediaMedium.js';
import '../Icons/IconMediaMute.js';
import '../Icons/IconMediaNext.js';
import '../Icons/IconMediaPause.js';
import '../Icons/IconMediaPlay.js';
import '../Icons/IconMediaRewind.js';
import '../Icons/IconMediaStop.js';
import '../Icons/IconMeetings.js';
import '../Icons/IconMenu.js';
import '../Icons/IconModule.js';
import '../Icons/IconMore.js';
import '../Icons/IconMove.js';
import '../Icons/IconNews.js';
import '../Icons/IconOpenContextualPanel.js';
import '../Icons/IconOpenPanel.js';
import '../Icons/IconPage.js';
import '../Icons/IconPageBack.js';
import '../Icons/IconPageDown.js';
import '../Icons/IconPageForward.js';
import '../Icons/IconPageUp.js';
import '../Icons/IconPaperclip.js';
import '../Icons/IconParagraph.js';
import '../Icons/IconPin.js';
import '../Icons/IconPresentation.js';
import '../Icons/IconPresentationMode.js';
import '../Icons/IconPreview.js';
import '../Icons/IconPreviewOff.js';
import '../Icons/IconPrint.js';
import '../Icons/IconPublish.js';
import '../Icons/IconPublishing.js';
import '../Icons/IconPushNotification.js';
import '../Icons/IconQuote.js';
import '../Icons/IconRecord.js';
import '../Icons/IconRecordActive.js';
import '../Icons/IconRedo.js';
import '../Icons/IconRefresh.js';
import '../Icons/IconRemoveFormatting.js';
import '../Icons/IconReorder.js';
import '../Icons/IconRotate.js';
import '../Icons/IconRSS.js';
import '../Icons/IconSave.js';
import '../Icons/IconScreen.js';
import '../Icons/IconScreenFitHeight.js';
import '../Icons/IconScreenFitWidth.js';
import '../Icons/IconScreenNext.js';
import '../Icons/IconScreenPrevious.js';
import '../Icons/IconScreenShare.js';
import '../Icons/IconSearch.js';
import '../Icons/IconSettings.js';
import '../Icons/IconShare.js';
import '../Icons/IconSharedLink.js';
import '../Icons/IconSortDown.js';
import '../Icons/IconSortUp.js';
import '../Icons/IconSoundOff.js';
import '../Icons/IconSoundOn.js';
import '../Icons/IconStatusAdd.js';
import '../Icons/IconStatusAddFilled.js';
import '../Icons/IconStatusCheck.js';
import '../Icons/IconStatusCheckFilled.js';
import '../Icons/IconStatusClose.js';
import '../Icons/IconStatusCloseFilled.js';
import '../Icons/IconStatusDot.js';
import '../Icons/IconStatusError.js';
import '../Icons/IconStatusHelp.js';
import '../Icons/IconStatusHelpFilled.js';
import '../Icons/IconStatusInformation.js';
import '../Icons/IconStatusInformationFilled.js';
import '../Icons/IconStatusPause.js';
import '../Icons/IconStatusPauseFilled.js';
import '../Icons/IconStatusPlay.js';
import '../Icons/IconStatusPlayFilled.js';
import '../Icons/IconStatusRemove.js';
import '../Icons/IconStatusRemoveFilled.js';
import '../Icons/IconStatusUrgent.js';
import '../Icons/IconStatusUrgentFilled.js';
import '../Icons/IconStatusWarning.js';
import '../Icons/IconSubtask.js';
import '../Icons/IconSync.js';
import '../Icons/IconTableColumn.js';
import '../Icons/IconTableGrid.js';
import '../Icons/IconTableRow.js';
import '../Icons/IconTags.js';
import '../Icons/IconTasks.js';
import '../Icons/IconTaxonomy.js';
import '../Icons/IconTemplate.js';
import '../Icons/IconText.js';
import '../Icons/IconTextCleared.js';
import '../Icons/IconTextField.js';
import '../Icons/IconTextImageLeft.js';
import '../Icons/IconTextImageRight.js';
import '../Icons/IconTextIndentLeft.js';
import '../Icons/IconTextIndentRight.js';
import '../Icons/IconTextSingle.js';
import '../Icons/IconTextSize.js';
import '../Icons/IconTextStrikethrough.js';
import '../Icons/IconTextSubscript.js';
import '../Icons/IconTextSuperscript.js';
import '../Icons/IconTextUnderline.js';
import '../Icons/IconTrendingDown.js';
import '../Icons/IconTrendingUp.js';
import '../Icons/IconTv.js';
import '../Icons/IconTwoColumn.js';
import '../Icons/IconUndo.js';
import '../Icons/IconUnlike.js';
import '../Icons/IconUnlink.js';
import '../Icons/IconUnlock.js';
import '../Icons/IconUnpublish.js';
import '../Icons/IconUpload.js';
import '../Icons/IconUser.js';
import '../Icons/IconUserAdd.js';
import '../Icons/IconUserAddToMeeting.js';
import '../Icons/IconUserGroup.js';
import '../Icons/IconUserRating.js';
import '../Icons/IconUserRemove.js';
import '../Icons/IconUserSearch.js';
import '../Icons/IconUserSettings.js';
import '../Icons/IconUserShare.js';
import '../Icons/IconUserSync.js';
import '../Icons/IconVariables.js';
import '../Icons/IconVideo.js';
import '../Icons/IconVideoPause.js';
import '../Icons/IconVideoRewind15.js';
import '../Icons/IconVideoSkip15.js';
import '../Icons/IconWorkspace.js';
import '../Icons/IconZoomIn.js';
import '../Icons/IconZoomOut.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "as", "tooltipProps", "onRemove"];
var TabWrapper = styled.div.withConfig({
  displayName: "StyledTab__TabWrapper",
  componentId: "sc-imh233-0"
})(["&&{padding:0 ", ";}&&:first-of-type{padding-inline-start:2px;}"], spacing2x);
var TabBorder = styled.div.withConfig({
  displayName: "StyledTab__TabBorder",
  componentId: "sc-imh233-1"
})(["&&{background:", ";border-radius:", " ", " 0 0;height:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.CTAColors.primary;
}, spacing1x, spacing1x, spacing1x);
var TextWrapper = styled.div.withConfig({
  displayName: "StyledTab__TextWrapper",
  componentId: "sc-imh233-2"
})(["&&{font-weight:normal;height:28px;max-width:200px;min-width:40px;overflow:hidden;padding:", ";text-decoration:none;text-overflow:ellipsis;white-space:nowrap;}&&:focus,&&:active{outline:none;text-decoration:none;}"], spacing1x);
var Tab = styled.div.withConfig({
  displayName: "StyledTab__Tab",
  componentId: "sc-imh233-3"
})(["&&{border-radius:", " ", " 0 0;cursor:pointer;display:block;font-size:14px;line-height:20px;margin:0 ", ";text-decoration:none !important;}&&:focus{outline:none;text-decoration:none;box-shadow:", ";}&&:first-of-type{margin-inline-start:0;}&&:last-of-type{margin-inline-end:0;}&& > ", "{visibility:hidden;}&&[aria-selected='true'] ", ",&&[aria-selected='true'] ", " *,&&[aria-current='page'] ", ",&&[aria-current='page'] ", " *{font-weight:600;color:", ";}&&[aria-selected='true'] > ", ",&&[aria-current='page'] > ", "{visibility:visible;}&& ", ",&& ", " *{color:", ";}&& ", ":hover,&& ", ":hover *{color:", ";}"], spacing1x, spacing1x, spacing2x, function (_ref2) {
  var theme = _ref2.theme;
  return "0 0 0 2px " + theme.CTAColors.primaryVariant;
}, TabBorder, TextWrapper, TextWrapper, TextWrapper, TextWrapper, function (_ref3) {
  var theme = _ref3.theme;
  return theme.CTAColors.primary;
}, TabBorder, TabBorder, TextWrapper, TextWrapper, function (_ref4) {
  var theme = _ref4.theme;
  return theme.neutralColors.charcoal;
}, TextWrapper, TextWrapper, function (_ref5) {
  var theme = _ref5.theme;
  return theme.CTAColors.primaryVariant;
});
var TabContent = styled.div.withConfig({
  displayName: "StyledTab__TabContent",
  componentId: "sc-imh233-4"
})(["&&{display:flex;justify-content:center;align-items:center;min-width:0%;}"]);
var RemoveButton = styled(Button).withConfig({
  displayName: "StyledTab__RemoveButton",
  componentId: "sc-imh233-5"
})(["&&{padding:2px;min-width:auto;min-height:0;line-height:0;border-radius:50%;align-self:auto;margin:0 ", ";}"], spacing1x);
var defaultElement = "div";
var StyledTab = /*#__PURE__*/React.forwardRef(function StyledTab2(props, ref) {
  var children = props.children,
      _props$as = props.as,
      as = _props$as === void 0 ? defaultElement : _props$as,
      tooltipProps = props.tooltipProps,
      onRemove = props.onRemove,
      rest = _objectWithoutProperties(props, _excluded);

  var _useIsTruncated = useIsTruncated(children),
      _useIsTruncated2 = _slicedToArray(_useIsTruncated, 2),
      textRef = _useIsTruncated2[0],
      truncated = _useIsTruncated2[1];

  var _useThemeContext = useThemeContext(),
      localization = _useThemeContext.localization;

  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
      t = _useTranslations.t;

  return /*#__PURE__*/jsx(TabWrapper, {
    children: /*#__PURE__*/jsxs(Tab, _objectSpread(_objectSpread({
      as: as
    }, rest), {}, {
      ref: ref,
      children: [/*#__PURE__*/jsxs(TabContent, {
        children: [/*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
          content: truncated ? onlyText(children) : void 0
        }, tooltipProps), {}, {
          children: /*#__PURE__*/jsx(TextWrapper, {
            ref: textRef,
            children: children
          })
        })), onRemove && /*#__PURE__*/jsx(RemoveButton, {
          tabIndex: -1,
          variant: "ghost",
          hideLabel: true,
          label: t("Tabs.removeTab"),
          startAdornment: /*#__PURE__*/jsx(IconClose, {
            height: 12,
            width: 12
          }),
          onClick: onRemove
        })]
      }), /*#__PURE__*/jsx(TabBorder, {
        "aria-hidden": true
      })]
    }))
  });
});
StyledTab.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "children": _PropTypes.node,
  "onRemove": _PropTypes.func,
  "tooltipProps": _PropTypes.object
};
StyledTab.__TYPE = "StyledTab";
StyledTab.displayName = StyledTab.__TYPE;

export { StyledTab, Tab, defaultElement };
